'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ModalContainer = require('../../lib/ModalContainer');

var _ModalContainer2 = _interopRequireDefault(_ModalContainer);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = require('merge-theme-hoc');

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'stopBodyScroll': 'Default__stopBodyScroll___3oNKK',
  'overlayDefault': 'Default__overlayDefault___1Vj5A',
  'overlayFadeStart': 'Default__overlayFadeStart___sMsD1',
  'overlayDefaultOpening': 'Default__overlayDefaultOpening___8a5KA',
  'overlayDefaultClosing': 'Default__overlayDefaultClosing___3ToWB',
  'modalDefault': 'Default__modalDefault___2BfP6',
  'modalMedium': 'Default__modalMedium___yt_fR',
  'modalLarge': 'Default__modalLarge___1yXsP',
  'modalHeightCenter': 'Default__modalHeightCenter___1uOBs'
};

var DefaultModalContainer = (0, _mergeThemeHoc2.default)(style)(_ModalContainer2.default);
DefaultModalContainer.displayName = 'DefaultModalContainer';
exports.default = DefaultModalContainer;


//////////////////
// WEBPACK FOOTER
// ./~/dibs-elements/dist/ModalContainer/index.js
// module id = 760
// module chunks = 4 5 8 9 14